import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-shipment-lists-editor',
  templateUrl: './shipment-lists-editor.component.html',
  styleUrls: ['./shipment-lists-editor.component.scss']
})
export class ShipmentListsEditorComponent {

  private params: any;
  initialType: string = ''
  initialTypes: string[] = []; // Add initialTypes array to store the initial selected types
  contact_uuid: string = ''
  typeList: string[] = [] // initialize the array to hold specific types depending on the array passed in the params
  isMultiple: boolean = false; // set a boolean to determine whether the type editor selection can select multiple values or not

  agInit(params: any): void {
    console.log('params', params)
    this.params = params;
    this.contact_uuid = this.params.data.contact_uuid
    this.typeList = this.params.types
    this.isMultiple = this.params.multiple

    // grab the current cell value of the contact's types
    const cellValue = params.value;

    // For initializing the mat-select when using the type-editor for a column in the subgrids (only 1 unique value)
    if (this.params.column.colId !== "return_status") {
      this.initialType = cellValue
      this.types.setValue(this.initialType)
    }

    // set the initial values of the mat-select to the current contact's types
    if (typeof cellValue === 'string' && cellValue.length > 0) {
      const selectTypes = cellValue.split(',').map((type: string) => type.trim());
      this.types.setValue(selectTypes);
      this.initialTypes = [...selectTypes]; // Store the initial selected types
    }
  }

  types: FormControl = new FormControl([]);

  constructor(private http: HttpClient) { }

  getValue(): any {

    // For editing SUBGRIDS of contact_details for specific columns that require a dropdown selection (only 1 type required)
    // no need to send a POST request in this method
    if (this.params.column.colId !== "return_status") {
      return this.types.value
    }

    // For editing the return_status in the MAIN contacts grid
    else {
      console.log('inside')
      const url = '/api/contacts/return_status.php'
      const selectedValues = this.types.value
      const selectedValuesIndex = this.types.value.map((value: string) => this.typeList.indexOf(value)); // map the indeces of all the values selected into an array

      var postData = {
        contact_uuid: this.contact_uuid,
        return_status: selectedValuesIndex
      }

      // this.http.post<any>(url, postData)
      //   .subscribe(response => {
      //     console.log('Post Response: ', response)
      //   })

      // Multiple values selected
      const typesString = selectedValues.join(',');
      return typesString; // return the types as a string to be displayed in the contact types cell renderer 
    }
  }

  stopEditing(): void {
    this.params.stopEditing();
  }

  revertChanges(): void {
    if (this.params.column.colId !== "return_status") { // reset mat-select to initial value for subgrid columns
      this.types.setValue(this.initialType)
    } else {
      this.types.setValue([...this.initialTypes]); // Reset the mat-select to initial values
    }
  }
}
